import { useState } from 'react'
import Select from 'react-select'

import { SelectData, SelectOptionString } from './models'
import { SelectStyles } from '../../../components/Select'
import { useThemeMode } from '../../../_metronic/partials'

export const selectType = 'simple_select'

const SimpleSelectFilter = (props: {
  options: Array<SelectOptionString>
  changeSelect: (selectData: SelectData) => void
  initialFilter?: SelectOptionString
  isMultiple?: boolean
  value?: string[]
}) => {
  const { mode: theme } = useThemeMode()
  const [keyUpdate, setKeyUpdate] = useState('1')

  const handleChange = (selectedData: any) => {
    const values = !selectedData
      ? []
      : !props.isMultiple
      ? [selectedData.value]
      : selectedData.map((item: SelectOptionString) => item.value)

    props.changeSelect({
      value: values,
      type: selectType,
    })
  }

  // Преобразуем значения в объекты опций для react-select
  const getValueFromProps = () => {
    if (!props.value) return props.initialFilter

    if (!props.isMultiple) {
      return props.options.find(option => option.value === props.value![0])
    } else {
      return props.options.filter(option => props.value!.includes(option.value))
    }
  }

  return (
    <Select
      key={`my_unique_select_key__${keyUpdate}`}
      value={props.value ? getValueFromProps() : undefined}
      defaultValue={!props.value ? props.initialFilter : undefined}
      onChange={handleChange}
      isClearable={props.options.some((v) => !v.isFixed)}
      isMulti={props.isMultiple}
      options={props.options}
      placeholder={'Выберите значение'}
      styles={SelectStyles(theme)}
    />
  )
}

export default SimpleSelectFilter
